import { PageHeader, Divider, Row, Col, Card, Button, Space, Form, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import React, { useEffect, useRef, useState } from 'react'
import CircularProgress from '../../components/CircularProgress'
import { getRoomsDetail, roomsSignin } from '../../appRedux/actions/Booking'
import './index.css'
import moment from 'moment'

export const InapPage = () => {
  const [data, setData] = useState(null)
  const [token, setToken] = useState(null)
  const prevData = useRef(null)
  const [audio] = useState(new Audio("/counter-up.mp3"))
  const gutter = [0, 2]

  function getData(newToken = null) {
    if (!token && !newToken)
      return
    const tokenUsed = newToken ? newToken : token
    getRoomsDetail(tokenUsed)
      .then(responseData => {
        prevData.current = data
        setData(responseData)
      }).catch(e => {
        setToken(null)
      })
  }

  function onLogin(values) {
    roomsSignin(values.password).then(responseData => {
      setToken(responseData.token)
      getData(responseData.token)
    })
  }

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    if (prevData.current) {
      if (JSON.stringify(data) !== JSON.stringify(prevData.current)) {
        audio.play()
      }
    }
    prevData.current = data
    const timeout = setTimeout(() => { getData() }, 10000)
    return () => clearTimeout(timeout)
  }, [data])

  return <>
    {!token ? (
      <>
        <div className="gx-app-login-wrap">
          <div className="gx-app-login-container">
            <div className="gx-app-login-main-content">
              <div className="gx-app-logo-content">
                <div className="gx-app-logo-content-bg">
                  <img alt="example" src="bg.jpg" />
                </div>
                <div className="gx-app-logo-wid">
                  <h1>
                    Login
                  </h1>
                  <p>
                    Silahkan login untuk mengakses halaman ini
                  </p>
                </div>
                <div className="gx-app-logo">
                  <img
                    alt="example"
                    src="/assets/images/logo-idn.png"
                    width="150"
                  />
                </div>
              </div>
              <div className="gx-app-login-content">
                <Form
                  initialValues={{ remember: true }}
                  name="basic"
                  layout="vertical"
                  onFinish={onLogin}
                  // onFinishFailed={onFinishFailed}
                  className="gx-signin-form gx-form-row0"
                >
                  <Form.Item
                    label="Password"
                    rules={[
                      { required: true, message: "Harap masukkan password!" },
                    ]}
                    name="password"
                  >
                    <Input
                      type="password"
                      placeholder="Masukkan Password"
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" className="gx-mb-0" htmlType="submit">
                      Login
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      <>
        {data == null ?
          <CircularProgress />
          :
          <>
            <div style={{
              padding: '0.2rem', height: '100%', overflowY: 'auto',
              // border: '4px solid red'
            }}>
              <Row style={{ padding: '0.3rem 0' }}>
                <Col span={12}>
                  <h1>DAFTAR TAMU MENGINAP ID-NETWORKERS</h1>
                </Col>
                <Col span={12} style={{ textAlign: 'right' }}>
                  <h1>{moment().utc().local().format("D MMMM YYYY")} (Jam Checkin: 18.00 WIB, Checkout: 13.00 WIB)</h1>
                </Col>
              </Row>
              <Row gutter={8} justify="space-around" align="top"
                style={{
                  // border: '4px solid blue',
                  height: '100%',
                }}>
                {data.map(d => (
                  <Col xs={24} md={12} lg={6}>
                    <div className='inap-card'>
                      <Row justify="space-around">
                        <Col span={8}>
                          <Space size={5}>
                            <img className='inap-icon' src={process.env.PUBLIC_URL + '/assets/images/inap/bed.png'} />
                            <span className='inap-number '>{d.number}</span>
                          </Space>
                        </Col>
                        <Col span={6}></Col>
                        <Col span={10}>
                          {(d.status == "canceled") ? (
                            <div className='inap-status-canceled'>
                              <Space size={5}>
                                <img className='inap-icon' src={process.env.PUBLIC_URL + '/assets/images/inap/canceled.png'} />
                                Kosong
                              </Space>
                            </div>
                          ) : (
                            <div className='inap-status-booked'>
                              <Space size={5}>
                                <img className='inap-icon' src={process.env.PUBLIC_URL + '/assets/images/inap/booked.png'} />
                                Terisi
                              </Space>
                            </div>
                          )}
                        </Col>
                      </Row>
                      <Row gutter={gutter} justify="space-around" align="top">
                        <Col span={24}>
                          <img className='inap-icon' src={process.env.PUBLIC_URL + '/assets/images/inap/people.png'} />
                          <b>{d.name ? d.name : "-"}</b>
                        </Col>
                        <Col span={24}>
                          <img className='inap-icon' src={process.env.PUBLIC_URL + '/assets/images/inap/company.png'} />
                          {d.company ? d.company : "-"}
                        </Col>
                        <Col span={12}>
                          <img className='inap-icon' src={process.env.PUBLIC_URL + '/assets/images/inap/check-in.png'} />
                          Check-in
                        </Col>
                        <Col span={12}>
                          <img className='inap-icon' src={process.env.PUBLIC_URL + '/assets/images/inap/check-out.png'} />
                          Check-out
                        </Col>
                        <Col span={12}>
                          <div className='inap-check'>
                            {d.start ? moment(d.start).utc().local().format("D MMMM YYYY") : '-'}
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className='inap-check'>
                            {d.end ? moment(d.end).utc().local().format("D MMMM YYYY") : '-'}
                          </div>
                        </Col>
                      </Row>
                      {(d.status == "canceled") ? (
                        <hr className='hr-canceled' />
                      ) : (
                        <hr className='hr-booked' />
                      )}
                      <div className='inap-footer'>
                        <Row justify="space-around" gutter={gutter}>
                          <Col span={24}>
                            <b className='inap-icon-text'>Tamu Berikutnya</b>
                          </Col>
                          <Col span={16}>
                            <img className='inap-icon-footer' src={process.env.PUBLIC_URL + '/assets/images/inap/people.png'} />
                            <b className='inap-icon-text'>{d.next_name ? d.next_name : "-"}</b>
                          </Col>
                          <Col span={8}>
                            <b className='inap-icon-text'>Check-in</b>
                          </Col>
                          <Col span={16}>
                            <img className='inap-icon-footer' src={process.env.PUBLIC_URL + '/assets/images/inap/company.png'} />
                            <span className='inap-icon-text'>{d.next_company ? d.next_company : "-"}</span>
                          </Col>
                          <Col span={8}>
                            <div className='inap-icon-text'>
                              {d.next_start ? moment(d.next_start).utc().local().format("D MMMM YYYY") : '-'}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </>
        }
      </>
    )}
  </>
}
